import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Pack, QueryListPacksForPurchaseArgs } from 'apollo/generated/types';
import getApiLanguage from 'i18n/apiLanguage';

const LIST_PACKS = gql`
  query listPacksForPurchase($date: String!, $language: Language) {
    listPacksForPurchase(date: $date, language: $language) {
      packImages {
        image
      }
      id
      name
      adultValue
      otherValue
      description
      remaining
      visibility
      status
    }
  }
`;

const useListPacksForPurchaseQuery = (date: string) => {
  const { i18n } = useTranslation();

  return useQuery<{ listPacksForPurchase: Pack[] }, QueryListPacksForPurchaseArgs>(
    LIST_PACKS,
    {
      variables: { date, language: getApiLanguage(i18n.language) },
    }
  );
};
export default useListPacksForPurchaseQuery;
